<template>
  <div class="yk-placeholder">
    <el-alert
      type="info"
      :closable="false"
      show-icon
      title="影控模块建设中"
      description="该模块暂未开放，后续功能逐步接入。"
    />
  </div>
</template>

<script>
export default {
  name: 'Yingkong',
}
</script>

<style scoped>
.yk-placeholder {
  padding: 40px 20px;
}
</style>



// WEBPACK FOOTER //
// src/admin/views/Yingkong.vue